<app-type-autres-infosATTR [uid]="getUid()" 
    [parentForm]="parentForm" [disabled]="disabled"
    [autresInformations]="typeAnn_DIVER_G2?.autresInformations">
</app-type-autres-infosATTR>   